<div class="page-title-area">
    <img src="assets/images/exclusiveapple.png" alt="Page Background" class="page-bg" style="width: 100%; height: 100%;">
    <!-- <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button> -->
    <div class="container">
        <div class="section-title program-title" style="text-align: center;">
            <h2 style="color: red !important; font-weight: 500;">Exclusive Apple Programs</h2>
            <!-- <h4 style="font-weight: 200; max-width: 90%;">Supercharge your code with the Mac for Developers Program—designed to make development smoother, faster, and smarter. Our all-in-one support model helps you handle every challenge while making the most of the Mac advantage. Let's build what's next, together</h4> -->
            <!-- <p>Supercharge your code with the Mac for Developers Program—designed to make development smoother, faster, and smarter. Our all-in-one support model helps you handle every challenge while making the most of the Mac advantage. Let's build what's next, together.</p> -->
        </div>
    </div>

</div>
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
        <div class="col-lg-4 col-md-6">
            <div class="service-card" [routerLink]="['/apple-program']" style="cursor: pointer;">
                <div class="card-image">
                    <img src="assets/images/program_apple.jpg" alt="Innovation">
                </div>
                <div class="card-content">
                    <h2 style="color: white;">Mac for Developers</h2>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="service-card" [routerLink]="['/impetus']" style="cursor: pointer;">
                <div class="card-image">
                    <img src="assets/images/impetus_banner_new.jpeg" alt="Security">
                </div>
                <div class="card-content">
                    <h2 style="color: white;">Mac Startup Accelerator</h2>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="service-card" [routerLink]="['/emp-purchase-program']" style="cursor: pointer;">
                <div class="card-image">
                    <img src="assets/images/emppurchaseprogram_banner.jpeg" alt="Support">
                </div>
                <div class="card-content">
                    <h2 style="color: white;">Employee Purchase Program</h2>
                    <!-- <p>Get unparalleled support from Apple-certified experts. From troubleshooting to optimization, we've got you covered.</p> -->
                </div>
            </div>
        </div>
        </div>
    </div>
</section>